import React from "react"
import Stack from "@kit/design/stack"
import Icon from "@kit/design/icon"

const Amount = ({ plan }) => {
  const interval = plan =>
    plan.interval === "month" ? "month" : "year (2 months free!)"

  if (plan.promo_code?.valid) {
    return (
      <>
        <span className="line-through">{plan.text}</span>{" "}
        <span className="font-semibold">
          {plan.promo_code.text} / {plan.interval}
        </span>
      </>
    )
  } else {
    return (
      <span>
        {plan.text}/{interval(plan)}
      </span>
    )
  }
}

export default function PlanVariantSwitch({
  handlePlanChange,
  activePlanId,
  availablePlans
}) {
  const handleClick = planId => {
    handlePlanChange(planId)
  }
  const planVariants = availablePlans

  const shortenLabel = label => {
    if (!label) return ""
    const words = label.trim().split(/\s+/)
    const lastWord = words[words.length - 1]
    return lastWord.charAt(0).toUpperCase() + lastWord.slice(1)
  }

  return (
    <div
      role="radiogroup"
      className={`grid grid-flow-row auto-rows-fr gap-4 mb-5 ${
        availablePlans.length === 2 ? "lg:grid-cols-2 lg:gap-10" : ""
      }`}
    >
      {planVariants.map(plan => {
        const isActive = activePlanId === plan.id

        const stateClass = isActive
          ? "border-black focus:border-blue-500"
          : "border-gray-50 focus:border-blue-500"

        return (
          <button
            key={plan.id}
            onClick={() => handleClick(plan.id)}
            role="radio"
            aria-checked={isActive}
            className={`flex items-center w-full rounded-lg p-4 cursor-pointer bg-gray-50 border transition-colors duration-200 ease-in-out focus:outline-none ${stateClass}`}
          >
            <div className="flex gap-3 items-start w-full">
              <DecorativeRadioButton active={isActive} />
              <Stack spacing={2} className="text-left">
                <div className="text-sm font-semibold w-full flex-grow text-black">
                  {shortenLabel(plan.label)}
                </div>
                <div className="text-sm text-left flex-shrink flex-grow-0 w-full text-black">
                  <Amount plan={plan} />
                </div>
              </Stack>
            </div>
          </button>
        )
      })}
    </div>
  )
}

function DecorativeRadioButton({ active }) {
  const stateClass = active ? "bg-black border-black" : "border-gray-300"

  return (
    <div
      className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors duration-200 ease-in-out ${stateClass}`}
    >
      {active && (
        <Icon
          name="check"
          className="text-white"
          style={{ width: 16, height: 16 }}
          aria-hidden="true"
        />
      )}
    </div>
  )
}
